/**
 * Display-only phone formatting (does not mutate stored values).
 * NANP (US/CAN): 10 digits → (XXX) XXX-XXXX; 11 starting with 1 → +1 (XXX) XXX-XXXX.
 */

function digitsOnly(s: string): string {
  return s.replace(/\D/g, '');
}

function formatNanp10(d: string): string {
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6, 10)}`;
}

export function formatPhoneDisplay(value: string | null | undefined): string {
  if (value == null) return '—';
  const raw = String(value).trim();
  if (!raw) return '—';

  const extMatch = raw.match(/\s*(?:ext\.?|x)\s*(\d+)\s*$/i);
  const ext = extMatch?.[1];
  const extIndex = extMatch?.index;
  const withoutExt =
    ext != null && extIndex != null ? raw.slice(0, extIndex).trim() : raw;

  const d = digitsOnly(withoutExt);

  let formatted: string;
  if (d.length === 10) {
    formatted = formatNanp10(d);
  } else if (d.length === 11 && d[0] === '1') {
    formatted = `+1 ${formatNanp10(d.slice(1))}`;
  } else if (withoutExt.startsWith('+')) {
    formatted = withoutExt.replace(/\s+/g, ' ').trim();
  } else {
    formatted = raw.replace(/\s+/g, ' ').trim();
  }

  if (ext) {
    return `${formatted} ext. ${ext}`;
  }
  return formatted;
}
